import MeasurementPage from '@app-studio-web/ui/pages/MeasurementPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'homeSize'

export default function HomeSizePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (
    value: string,
    unit: string,
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'How big is your home?',
      answer_key: value.toLowerCase(),
      answer: `${value} ${unit}`,
    }

    const formData = new FormData(event.currentTarget)
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <MeasurementPage
      heading={t('pages.onboarding.homeSize.heading')}
      description={t('pages.onboarding.homeSize.description')}
      placeholders={{ 'm²': '160' }}
      units={['m²']}
      defaultUnit="m²"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
